__turbopack_context__.v({
  "conditions__notationBtn": "ConditionsNotation-module-scss-module__i5bP9G__conditions__notationBtn",
  "conditions__notationItem": "ConditionsNotation-module-scss-module__i5bP9G__conditions__notationItem",
  "conditions__notationLink": "ConditionsNotation-module-scss-module__i5bP9G__conditions__notationLink",
  "conditions__notationList": "ConditionsNotation-module-scss-module__i5bP9G__conditions__notationList",
  "conditions__notationList_full": "ConditionsNotation-module-scss-module__i5bP9G__conditions__notationList_full",
  "conditions__notationTitle": "ConditionsNotation-module-scss-module__i5bP9G__conditions__notationTitle",
  "conditions__notationWrapper": "ConditionsNotation-module-scss-module__i5bP9G__conditions__notationWrapper",
});
